// Dev/prod API base. CRA sets NODE_ENV=development for `npm start` (local dev
// server) and production for `npm run build`. So local dev hits the local
// backend (localhost:8082, matching the backend's `npm run dev` CORS), and the
// deployed build hits production. Override with REACT_APP_API_URL if needed.
export const baseUrl =
  process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === 'development'
    ? 'http://localhost:8082/api/'
    : 'https://timesheet.1maintenance.com.au/api/');

// --- Shared formatting helpers (used across the timesheet/payout views) ---

// "$1,234.56" - the app's money format (was inlined with a regex everywhere).
export const fmtMoney = (n) => {
  const v = Number(n) || 0;
  return '$' + v.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
};

// --- Client-side CSV export (no backend endpoint needed) ---
// columns: [{ key, label, map? }]. rows: array of objects.
export const toCsv = (rows, columns) => {
  const esc = (val) => {
    const s = val === null || val === undefined ? '' : String(val);
    return /[",\n]/.test(s) ? '"' + s.replace(/"/g, '""') + '"' : s;
  };
  const header = columns.map((c) => esc(c.label)).join(',');
  const body = (rows || [])
    .map((row) => columns.map((c) => esc(c.map ? c.map(row) : row[c.key])).join(','))
    .join('\n');
  return header + '\n' + body;
};

export const downloadCsv = (filename, csv) => {
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};
